import { ref } from 'vue';

export default function useOpeningHours(array) {
  const { t } = useI18n();
  const getTranslation = (index) => t(`global.weekdays.day-short-${index}`);

  const arr = ref(array);
  const openingHours = (val) => val.slice(0, val.length - 3).replace(':', '.');

  const transformedArray = arr.value.map((x) => ({
    ...x,
    from: openingHours(x.from),
    to: openingHours(x.to),
  }));

  const obj = transformedArray.reduce((acc, item) => {
    const key = `${item.from}–${item.to}`;
    acc[key] = acc[key] ? [...acc[key], item.day_in_week] : [item.day_in_week];
    return acc;
  }, {});

  const dayHours = Object.keys(obj).map((curr) => {
    const daysArr = obj[curr];
    const days =
      daysArr.length === 1
        ? getTranslation(daysArr[0])
        : daysArr.every((item, index) => index === 0 || item === daysArr[index - 1] + 1)
          ? `${getTranslation(daysArr[0])}–${getTranslation(daysArr[daysArr.length - 1])}`
          : daysArr.map(getTranslation).join(', ');
    return `${days}: ${curr}`;
  });
  return dayHours;
}
